<template>
  <div class="vlt-menu">
    <div class="vlt-menu-contain">
      <div class="vlt-menu-csec">
        <div class="profile">
      <div class="menu-profile-image">
          <img
            v-if="picture"
            :src="picture"
            alt="vlt-prof"
            class="profile-img-responsive" />
            <!-- <div class="profile-default" v-else>
              <p>G</p>
            </div> -->
          <img
          v-else
            :src="defaultPicture"
            style="margin-left: 15%;"
            alt="vlt-prof"
             />
            <div @click="openEditProfilePopup" class="profile-edit">
              <img src="@/assets/icons/edit.png" alt="edit icon"/>
            <!-- <span>Edit</span> -->
            </div>            
        </div>
        <p class="user-name">{{ AppUser.subscribername }}</p>
        <p class="user-email">{{ AppUser.email }}</p>
        <p @click="changePassword" class="change-password">Change Password</p>
    </div>

        <div class="vlt-menus">
          <ul @click="closeMenu(false)">
            
            <li
              class=""
              v-if="subscriberid" @click="openNotificationPopup">
              <a>
                  Notifications
                  <span>
                    <button
                      type="button"
                      class="vlt-btn-ico" style="padding:0px;" >
                      <img
                        src="@/assets/icons/notification-dark.svg"
                        alt="notif-ico">
                        <span v-if="newMessage"  class="badge"></span>
                    </button>
                  </span>
              </a>
            </li>
            <!-- <li class="vlt-menu-hlt"></li> -->
            <li v-if="subscriberid">
              <!-- <router-link :to="{ name: 'settings' }" class="menu-button-hover">Settings</router-link> -->
              <router-link :to="{ name: 'settings' }" @click="settingsClick">
                <div class="row">
                  <div class="col-lg-10 col-sm-10 col-xs-10 col-md-10" style="padding: 0;">
                    <p class="meta-link">Settings</p>
                  </div>
                  <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2">
                    <img class="menu-icons" src="@/assets/icons/Settings.svg">
                  </div>                  
                </div>
              </router-link>
            </li>
            <li v-if="subscriberid">
              <a
                @click.prevent="logoutCB" class="menu-button-hover">
                <div class="row">
                  <div class="col-lg-10 col-sm-10 col-xs-10 col-md-10" style="padding: 0;">
                    <p class="meta-link">Sign Out</p>
                  </div>
                  <div class="col-lg-2 col-sm-2 col-xs-2 col-md-2">
                    <img class="menu-icons" src="@/assets/icons/Signout.svg">
                  </div>                  
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="vlt-menu-close" @click="closeMenu(false)">
        <img src="@/assets/icons/Close.png" alt="close-ico">
      </div>
    </div>

    <div class="vlt-menu-overlay" @click="closeMenu(false)"></div>
  </div>
</template>

<script>
import { EventBus } from '@/main';
import { mapGetters } from 'vuex';
import App from '@/mixins/App';
import User from '@/mixins/User';
import GoogleAnalytics from '@/mixins/GoogleAnalytics';

export default {
  name: 'HeaderMenu',
  props: [
    'closeMenu',
    'categories',
    'openSubscribePopup'
  ],
  data () {
    return {
      showMenuProfile: false,
      showProfilePhoto: false,
      defaultPicture: require('@/assets/icons/user-black.png')
    }
  },
  created () {
    EventBus.$on('logoutError', (error) => {
      let GA = {
        'Event Label': 'Failure', 
        Status: 'FAILURE',
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      }
      this.logoutEvent(GA)
    })
    EventBus.$on('logoutSuccess', () => {
      let GA = {
        'Event Label': 'Success',
        Status: 'SUCCESS'
      }
      this.logoutEvent(GA)
    })
  },
  computed: {
    ...mapGetters([
      'subscriberid',
      'picture',
      'AppUser',
      'newMessage'
    ]),
    profilePic () {
      if (this.AppUser.picture) {
        return this.AppUser.picture;
      }
      return this.defaultProfilePic;
    }
  },
  methods: {
    settingsClick () {
      let GA = {
        MenuItem: 'Settings'
      }
      this.menuEvent(GA)
    },
    logoutCB () {
      let GA = {
        MenuItem: 'Signout'
      }
      this.menuEvent(GA)
      //
      this.showLoading = true;
      EventBus.$emit('logOut');
    },
    openNotificationPopup () {
      EventBus.$emit('NotificationPopup');
      this.closeMenu (false);
    },
    changePassword () {
      EventBus.$emit('ChangePasswordPopup');
      this.closeMenu (false);
    },
    openEditProfilePopup () {
      EventBus.$emit('EditProfile');
      this.closeMenu (false);
    },
    editProfile () {
    }
  },
  mixins: [ App, User, GoogleAnalytics ]
}
</script>

<style lang="scss">
@import '~sass/modules/components';
.badge {
    position: relative;
    top: 27%;
    border-radius: 50%;
    background-color: #FB6126;
    width: 7px;
    height: 7px;
    font-size: 12px;
    font-weight: bold;
}
.close-cont {
  overflow: hidden;
}
.vlt-ms-pr {
    padding: 1em 0;
    margin-bottom: 1em;
    border-bottom: 1px solid #c3c3c3;
}
.vlt-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8888;
  .vlt-menu-contain {
    position: absolute;
    height: 100%;
    background-color: #ffffff;
    z-index: 999;
    width: 280px;
    right: 0;
  }
  .vlt-menu-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background-color: $clr-dark-hlt;
    height: 100%;
    z-index: 998;
  }
  .menu-unsub-btn {
    margin: 10px 0;
  }
  .vlt-menu-csec {
    position: absolute;
    padding: 0 20px;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    padding-bottom: 20px;
  }
  .vlt-ms-profile {
    padding: 15px;
    border-bottom: 1px solid $clr-white-2;

    .vlt-ms-pr {
      float: left;
      p {
        font-size: $text-xs;
      }
    }
    .vlt-ms-settings {
      float: right;
    }
    .vlt-ms-pr-img {
      margin-bottom: 5px;
      img, h5 {
        float: left;
      }
      h5 {
        padding: 8px 0;
      }
      img {
        width: 40px;
        border-radius: 30px;
      }
      .profile-edit{
        cursor: pointer;
        margin-top: 5px;
        img{
          border-radius: 0px;
          width: 15px;
          margin-right: 5px;          
        }
      }
    }
  }
  // menu
  .vlt-menus {
    ul {
      li {
        a, .meta-links {
          display: block;
          padding: 12px 15px;
          font-size: 16px;
          color: #212121;	
          font-family: "ProximanovaSemibold";	
          line-height: 27px;
        }
        .menu-icons{
          width: 30px;
        }

        .vlt-btn-ico {
          img {
            width: 20px;
          }
        }
        span {
          float: right;
        }

        &.vlt-menu-hlt {
          border-bottom: 1px solid $clr-white-2;
        }
      }
    }
  }
  .vlt-menu-close {
    position: absolute;
    display: inline-block;
    top: 5px;
    left: -40px;
    width: 40px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    img {
      width: 25px;
    }
  }
}
.menu-button-hover{
  opacity: .8;
  &:hover{
    opacity: 1;
    font-weight: 600;
  }
}
.menu-profile-image{
  text-align: center;
  margin-top: 25px;
  .profile-img-responsive{
    margin-left: 10%;
    width: 80px;
    cursor: pointer;
    border-radius: 50%;
  }
  .profile-edit{
    float: right;
    cursor: pointer;
    img{
      width: 12px;
      opacity: 0.85;
      &:hover{
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Menu/Menu.vue